import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ImportTransactionTypePayload {
  file: File;
}

export const useAdminImportTransactionType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportTransactionTypePayload) => {
      const formData = new FormData();
      formData.append('file', payload.file);

      await request({
        path: 'transaction-type/import-transaction-type',
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['transaction-types'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Failed to import transaction type');
    },
  });
};
